import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function Abminderungsfaktor({ abminderungsfaktor }) {
  const { t } = useTranslation("translation");
  const AbminderungsfaktorFormula = `\\displaystyle \\chi = \\frac{1}{\\Phi + \\sqrt{\\Phi^2-\\bar{\\lambda}^2}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.dinEN1993.verification.reductionFactor")}</p>}
      formulaValue={
        <ToolTip
          id={"AbminderungsfaktorFormula"}
          type={IconType.FORMULA}
          formula={AbminderungsfaktorFormula}
        />
      }
      indicesValue={
        <>
          {/* TODO: fix visual, shows as X instead of Chi */}
          <span>&chi;</span>
        </>
      }
      inputValue={<span className="input">{ConvertToString(abminderungsfaktor, 2)}</span>}
    />
  );
}

export default Abminderungsfaktor;
